import { create } from 'zustand';

/* What a 402 told this tab — shared by the watcher and the banner. */

export interface RefusalState {
  /** The last 402 this tab received, per clinic — `null` until one arrives. */
  refusal: { clinicId: string | null; code: string; message: string } | null;
  record: (refusal: RefusalState['refusal']) => void;
  clear: () => void;
}

/**
 * Module-level, not React state: the watcher and the banner are siblings in
 * the shell, and a clinic switch must not carry clinic A's refusal into B —
 * hence the clinic id on the record.
 */
export const useBillingRefusal = create<RefusalState>()((set) => ({
  refusal: null,
  record: (refusal) => set({ refusal }),
  clear: () => set({ refusal: null }),
}));
